import type { ReactNode } from "react";
import type { Audit } from "@/services/api/guardiansv2/types";

export interface AuditRawInputsProps {
  audit: Audit;
  /** Shown opposite the raw JSON toggle (e.g. persona rerun icons). */
  actions?: ReactNode;
}

/** Collapsible full audit inputs / scope / subject JSON (no clipboard actions). */
export function AuditRawInputs({ audit, actions }: AuditRawInputsProps) {
  const payload = {
    inputs: audit.inputs,
    scope: audit.scope,
    subject: audit.subject,
  };

  return (
    <div className="mt-8 border-t border-white/5 pt-4" data-testid="audit-raw-json-row">
      <div className="flex items-center justify-between gap-3">
        <details className="group min-w-0 flex-1" data-testid="audit-raw-json">
          <summary className="cursor-pointer text-xs font-medium text-slate-400 hover:text-slate-300">
            See raw JSON
          </summary>
          <pre className="mt-2 max-h-80 overflow-auto rounded-xl bg-slate-900/60 p-3 text-[11px] leading-relaxed text-slate-300 whitespace-pre-wrap break-words">
            {JSON.stringify(payload, null, 2)}
          </pre>
        </details>
        {actions}
      </div>
    </div>
  );
}
